// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgMoveFolder24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M5.50282 13.8256L7.68854 14.7599L7.31997 14.8542C6.59997 15.0342 5.52854 15.4114 4.53425 16.1571C3.48854 16.9456 2.21997 18.3856 2.14282 20.7771V20.8628H3.57425V20.7771C3.63425 19.3285 4.24282 18.1628 5.39139 17.2971C6.36854 16.5685 7.45711 16.2685 8.02282 16.1571L8.26282 16.1056L7.31139 18.3256L8.62282 18.8914L10.5085 14.4942L10.5428 14.4171L6.06854 12.4971L5.50282 13.8085V13.8256Z" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M20.8254 6.67777V8.02172C21.8826 8.27259 22.2858 9.27608 22.2858 9.98389V17.1158C22.2858 18.3164 21.3092 19.293 20.1086 19.293H12.0001V17.9491H20.1086C20.5655 17.9491 20.9418 17.5727 20.9418 17.1158H20.9329V9.98389C20.9239 9.67926 20.8074 9.31192 20.2967 9.31192H12.7796C11.561 9.31192 10.7368 8.32635 10.6472 8.21884L9.46448 6.59713C9.46367 6.59592 9.46258 6.59426 9.46121 6.59218C9.40216 6.50249 8.82741 5.62949 8.01301 5.62949H3.89156C3.43461 5.62949 3.05831 6.00579 3.05831 6.46274V14.5714H1.71436V6.46274C1.71436 5.26214 2.69096 4.28554 3.89156 4.29449H8.00405C8.64019 4.29449 9.15985 4.53641 9.572 4.82312L19.0782 4.91271C19.7233 4.91271 20.1265 5.1815 20.3415 5.4055C20.8266 5.89935 20.8255 6.57549 20.8254 6.67352L20.8254 6.67777ZM19.4814 7.95901V6.65089C19.4814 6.24771 19.2216 6.24771 19.0782 6.24771L10.8174 6.16707L11.7134 7.39455C11.8298 7.52894 12.2868 7.95901 12.7796 7.95901H19.4814Z"
				/>
			</Svg>
		);
	}
);
SvgMoveFolder24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgMoveFolder24;
